module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-00.2.2d5921b5.jpg";